import React, { Component, NavLink } from "react";
import UserService from "../services/user.service";
import { Redirect } from "react-router-dom";
import _ from "lodash";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { connect } from "react-redux";
import { logout } from "../actions/auth";
import { Coins } from "../config/clientconfig";

// import SidebarCoin from "./sidebarcoin-component";
import { ToastContainer, toast } from "react-toastify";
import { combineReducers } from "redux";
var ws;
var messageID;
var subscriptions = [];
var pendingMessages;
var subscribeAddressesId = "";

class Sidebar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Balance: [],
            ws: null,
            coindetail: [],
        };

        this.subscribe = this.subscribe.bind(this);
        this.subscribeAddresses = this.subscribeAddresses.bind(this);
        this.connect = this.connect.bind(this);
        this.logOut = this.logOut.bind(this);
    }

    componentWillMount() {
        UserService.getCoindetail().then(
            (response) => {
                if (response.data.code == 100) {
                    this.setState({
                        coindetail: response.data.coinDetail,
                    });
                    for (var i = 0; i < response.data.coinDetail.length; i++) {
                        if (
                            response.data.coinDetail[i].Ticker != "ETH" &&
                            response.data.coinDetail[i].Ticker != "BNB" &&
                            response.data.coinDetail[i].Ticker != "WVSOL-BNB" &&
                            response.data.coinDetail[i].Ticker != "WVSOL-ETH" &&
                            response.data.coinDetail[i].Ticker != "USDT" &&
                            response.data.coinDetail[i].Ticker != "BUSD" &&
                            response.data.coinDetail[i].Ticker == this.props.coin
                        ) {
                            this.connect(response.data.coinDetail[i].ExpolrerUrl, response.data.coinDetail[i].Addresses);
                        }
                    }
                }
            },
            (error) => {
                this.setState({
                    content: (error.response && error.response.data) || error.message || error.toString(),
                    isLoading: false,
                });
            }
        );
    }

    logOut() {
        this.props.dispatch(logout());
    }

    timeout = 200;
    unsubscribe(method, id, params, callback) {
        delete subscriptions[id];
        pendingMessages[id] = callback;
        var req = {
            id,
            method,
            params,
        };
        ws.send(JSON.stringify(req));
        return id;
    }

    subscribe(method, params, callback) {
        var id = messageID.toString();
        messageID++;
        subscriptions[id] = callback;

        var req = {
            id,
            method,
            params,
        };

        if (ws.readyState !== WebSocket.OPEN) return;
        ws.send(JSON.stringify(req));
        return id;
    }

    connect(server, Addresses) {
        messageID = 0;
        var pendingMessages = {};
        var subscriptions = {};
        var connectInterval;

        if (server.startsWith("http")) {
            server = server.replace("http", "ws");
        }
        if (!server.endsWith("/websocket")) {
            server += "websocket";
        }

        ws = new W3CWebSocket(server);

        ws.onopen = (e) => {
            //  console.log('connnectt', e);
            this.setState({ ws: ws });
            this.timeout = 250; // reset timer to 250 on open of websocket connection
            clearTimeout(connectInterval);
            this.subscribeAddresses(Addresses);
        };
        ws.onclose = (e) => {
            // console.log('socket closed', e);
            var url = e.target.url.replace("ws", "http");
            this.timeout = this.timeout + this.timeout; //increment retry interval
            connectInterval = setTimeout(() => {
                this.check(url); //call check function
            }, Math.min(10000, this.timeout));
        };

        ws.onerror = (e) => {
            // console.log('socket error ', e);
        };
        ws.onmessage = (e) => {
            var resp = JSON.parse(e.data);
            var f = resp.data.address;
            if (f != undefined) {
                var coinname;
                if (resp.data.address.startsWith("S")) {
                    coinname = "VSOL";
                } else if (resp.data.address.startsWith("V")) {
                    coinname = "VDM";
                } else if (resp.data.address.startsWith("D")) {
                    coinname = "DOGE";
                } else {
                    coinname = "BTC";
                }

                toast.info("New Transaction on " + coinname + " " + resp.data.tx.txid);
                setTimeout(function () {
                    window.location.reload();
                }, 10000);
            } else {
            }
        };
    }

    check = async (url) => {
        const { ws } = this.state;
        url = url.replace("websocket", "");
        if (!ws || ws.readyState == WebSocket.CLOSED) {
            var data = await _.find(this.state.coindetail, { ExpolrerUrl: url });
            if (data && data.Ticker != "ETH" && data.Ticker != "BNB" && data.Ticker != "WVSOL-BNB" && data.Ticker != "WVSOL-ETH" && data.Ticker != "USDT" && data.Ticker != "BUSD") {
                this.connect(data.ExpolrerUrl, data.Addresses); //check if websocket instance is closed, if so call `connect` function.
            }
        }
    };

    subscribeAddresses(Addresses) {
        const method = "subscribeAddresses";
        const params = {
            Addresses,
        };

        if (subscribeAddressesId) {
            delete subscriptions[subscribeAddressesId];
            subscribeAddressesId = "";
        }

        subscribeAddressesId = this.subscribe(method, params, function (result) {
            return result;
        });
    }

    render() {
        const dashboardClass = window.location.href.includes("dashboard") ? "active" : "";
        const Paymentclass = window.location.href.includes("PaymentBox") ? "active" : "";
        const Walletclass = window.location.href.includes("/wallet") ? "active" : "";

        return (
            <>
                <ToastContainer />

                <aside className="sidebar sidebar-default navs-rounded-all">
                    <div className="sidebar-header d-flex align-items-center justify-content-start">
                        <a href="#" className="navbar-brand justify-content-center">
                            <img src="../assets/images/NOVA-1.png" alt="" className="" width="65%" />
                            {/* <h4 className="logo-title">Wallet</h4> */}
                        </a>
                        <div className="sidebar-toggle" data-toggle="sidebar" data-active="true">
                            <i className="icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.25 12.2744L19.25 12.2744" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path>
                                    <path d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path>
                                </svg>
                            </i>
                        </div>
                    </div>
                    <div className="sidebar-body pt-0 data-scrollbar">
                        <div className="sidebar-list">
                            <ul className="navbar-nav iq-main-menu" id="sidebar-menu">
                                <li className={"nav-item " + dashboardClass}>
                                    <a className={"nav-link " + dashboardClass} aria-current="page" href={"/dashboard/" + this.props.coin}>
                                        <i className="icon">
                                            <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    opacity="0.4"
                                                    d="M16.0756 2H19.4616C20.8639 2 22.0001 3.14585 22.0001 4.55996V7.97452C22.0001 9.38864 20.8639 10.5345 19.4616 10.5345H16.0756C14.6734 10.5345 13.5371 9.38864 13.5371 7.97452V4.55996C13.5371 3.14585 14.6734 2 16.0756 2Z"
                                                    fill="currentColor"
                                                ></path>
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                                                    fill="currentColor"
                                                ></path>
                                            </svg>
                                        </i>
                                        <span className="item-name">Dashboard</span>
                                    </a>
                                </li>

                                {Coins.map((item) => (
                                    <li className={window.location.href.includes("wallet/" + item.Ticker) ? "nav-item active" : "nav-item"}>
                                        <a className={window.location.href.includes("wallet/" + item.Ticker) ? "nav-link active" : "nav-link"} aria-current="page" href={"/wallet/" + item.Ticker}>
                                            <img className="" src={"../assets/images/coins/" + item.Ticker + ".png"} style={{ width: "24px", height: "24px" }} />
                                            {<span className="item-name">{item.Name + " " + item.TokenType}</span>}
                                        </a>
                                    </li>
                                ))}

                                <li className={"nav-item " + Paymentclass}>
                                    <a className={"nav-link " + Paymentclass} aria-current="page" href={"/PaymentBox"}>
                                        <i className="icon">
                                            <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M17.7689 8.3818H22C22 4.98459 19.9644 3 16.5156 3H7.48444C4.03556 3 2 4.98459 2 8.33847V15.6615C2 19.0154 4.03556 21 7.48444 21H16.5156C19.9644 21 22 19.0154 22 15.6615V15.3495H17.7689C15.8052 15.3495 14.2133 13.7975 14.2133 11.883C14.2133 9.96849 15.8052 8.41647 17.7689 8.41647V8.3818ZM17.7689 9.87241H21.2533C21.6657 9.87241 22 10.1983 22 10.6004V13.131C21.9952 13.5311 21.6637 13.8543 21.2533 13.8589H17.8489C16.8548 13.872 15.9855 13.2084 15.76 12.2643C15.6471 11.6783 15.8056 11.0736 16.1931 10.6122C16.5805 10.1509 17.1573 9.88007 17.7689 9.87241ZM17.92 12.533H18.2489C18.6711 12.533 19.0133 12.1993 19.0133 11.7877C19.0133 11.3761 18.6711 11.0424 18.2489 11.0424H17.92C17.7181 11.0401 17.5236 11.1166 17.38 11.255C17.2364 11.3934 17.1555 11.5821 17.1556 11.779C17.1555 12.1921 17.4964 12.5282 17.92 12.533ZM6.73778 8.3818H12.3822C12.8044 8.3818 13.1467 8.04812 13.1467 7.63649C13.1467 7.22487 12.8044 6.89119 12.3822 6.89119H6.73778C6.31903 6.89116 5.9782 7.2196 5.97333 7.62783C5.97331 8.04087 6.31415 8.37705 6.73778 8.3818Z"
                                                    fill="currentColor"
                                                ></path>
                                            </svg>
                                        </i>
                                        <span className="item-name"> Nova Payment Box</span>
                                    </a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link" aria-current="page" onClick={this.logOut}>
                                        <i className="icon">
                                            <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M15.016 7.38948V6.45648C15.016 4.42148 13.366 2.77148 11.331 2.77148H6.45597C4.42197 2.77148 2.77197 4.42148 2.77197 6.45648V17.5865C2.77197 19.6215 4.42197 21.2715 6.45597 21.2715H11.341C13.37 21.2715 15.016 19.6265 15.016 17.5975V16.6545"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                ></path>
                                                <path d="M21.8096 12.0215H9.76855" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                <path d="M18.8813 9.1062L21.8093 12.0212L18.8813 14.9372" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                            </svg>
                                        </i>
                                        <span className="item-name">Logout</span>
                                    </a>
                                </li>

                                <hr />

                                <li className="nav-item">
                                    <a className="nav-link" aria-current="page" href="https://vsolidus.com/technicalsupport" target="_blank">
                                        <i className="icon">
                                            <img alt="Help icon" srcSet="https://img.icons8.com/material-outlined/2x/help.png 2x" style={{ height: "24px", width: "24px" }} />
                                        </i>
                                        <span className="item-name">Help</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </aside>
            </>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.auth;
    return {
        user,
    };
}

export default connect(mapStateToProps)(Sidebar);

